import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const Duolingo: React.FC<IconProps> = ({ size, style, color, secondaryColor }) => {
  const theme = useTheme();

  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? '20'}
      height={size ?? '21'}
      fill="none"
      viewBox="0 0 250 250"
      data-testid="duolingo-icon"
    >
      <path
        fill={color ?? '#50C800'}
        fillRule="evenodd"
        d="M47.583 0h154.858C228.711 0 250 21.29 250 47.583v154.858c0 26.27-21.289 47.583-47.583 47.583H47.583C21.289 250 0 228.711 0 202.417V47.583C0 21.289 21.29 0 47.583 0Z"
        clipRule="evenodd"
      />
      <path
        fill={color ? secondaryColor || theme.palette.primary.main : '#8EE000'}
        fillRule="evenodd"
        d="M250.008 161.499V89.185a56.656 56.656 0 0 0-12.182-18.36c.464-7.764-1.27-15.625-5.298-22.632-2.637-4.59-9.009-5.249-12.573-1.294l-8.081 8.96c-.049-.024-.098-.024-.147-.048 1.05-8.18-.342-16.626-4.346-24.17-2.49-4.688-7.885-5.518-11.596-1.71l-38.819 39.332c-.439.415-.903.854-1.342 1.294-.025.024-.074.049-.098.073-16.87 15.283-43.164 15.918-59.229 1.88a55.108 55.108 0 0 0-3.15-3.174l-38.89-39.38c-3.712-3.808-9.107-2.978-11.597 1.71-3.98 7.519-5.396 15.917-4.37 24.047-.074.024-.147.024-.22.049l-7.984-8.863c-3.564-3.955-9.936-3.296-12.597 1.294-3.955 6.86-5.689 14.551-5.323 22.168a57.148 57.148 0 0 0-12.182 17.7v74.585c8.765 19.996 28.735 33.985 51.953 33.985h2.49c23.023 0 42.847-13.745 51.709-33.472 8.521-.049 14.697-.073 18.531-.073 8.3-.024 14.77-.024 19.409-.024 8.838 19.775 28.711 33.569 51.757 33.569h1.758c23.658 0 43.921-14.527 52.417-35.132Z"
        clipRule="evenodd"
      />
      <path
        fill={color ? secondaryColor || theme.palette.primary.main : '#fff'}
        fillRule="evenodd"
        d="M55.453 74.219c21.777 0 39.453 17.65 39.453 39.453v23.364c0 21.777-17.652 39.453-39.453 39.453-21.778 0-39.454-17.651-39.454-39.453v-23.364c0-21.802 17.676-39.453 39.454-39.453ZM194.052 74.219c21.777 0 39.453 17.65 39.453 39.453v23.364c0 21.777-17.652 39.453-39.453 39.453-21.778 0-39.454-17.651-39.454-39.453v-23.364c0-21.802 17.652-39.453 39.454-39.453Z"
        clipRule="evenodd"
      />
      <path
        fill={color ?? '#4B4B4B'}
        fillRule="evenodd"
        d="M61.532 96.875c10.327 0 18.725 8.374 18.725 18.726v19.995c0 10.327-8.374 18.725-18.725 18.725-10.327 0-18.726-8.374-18.726-18.725v-19.995c0-10.352 8.399-18.726 18.726-18.726Z"
        clipRule="evenodd"
      />
      <path
        fill={color ? secondaryColor || theme.palette.primary.main : '#F48000'}
        fillRule="evenodd"
        d="M125.01 142.266c11.84 0 21.435 9.595 21.435 21.435v7.447c0 11.841-9.595 21.435-21.435 21.435-11.841 0-21.436-9.594-21.436-21.435v-7.447c0-11.84 9.595-21.435 21.436-21.435Z"
        clipRule="evenodd"
      />
      <path
        fill={color ? secondaryColor || theme.palette.primary.main : '#FFC200'}
        d="M95.42 165.752c2.563-13.671 15.234-23.535 30.395-23.535 13.794 0 26.27 10.108 28.784 23.535v1.099c0 .855-.293 1.196-1.074 1.099l-27.685 4.931h-1.636l-27.71-4.956c-.781.098-1.074-.244-1.074-1.098v-1.075Z"
      />
      <path
        fill={color ? secondaryColor || theme.palette.primary.main : '#FFE747'}
        fillRule="evenodd"
        d="M120.468 146.953a19.25 19.25 0 0 1 4.419-.537c1.587 0 3.199.196 4.786.611a7.285 7.285 0 0 1 5.468 7.055 4.83 4.83 0 0 1-4.834 4.834h-10.595a4.83 4.83 0 0 1-4.834-4.834c-.025-3.369 2.295-6.323 5.59-7.129Z"
        clipRule="evenodd"
      />
      <path
        fill={color ?? '#4B4B4B'}
        fillRule="evenodd"
        d="M187.972 96.875c10.328 0 18.726 8.374 18.726 18.726v19.995c0 10.327-8.374 18.725-18.726 18.725-10.327 0-18.725-8.374-18.725-18.725v-19.995c.024-10.352 8.398-18.726 18.725-18.726Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M45.711 119.58c6.675 0 12.085-5.389 12.085-12.036 0-6.647-5.41-12.036-12.085-12.036-6.674 0-12.084 5.389-12.084 12.036 0 6.647 5.41 12.036 12.084 12.036ZM170.321 119.58c6.674 0 12.085-5.389 12.085-12.036 0-6.647-5.411-12.036-12.085-12.036-6.675 0-12.085 5.389-12.085 12.036 0 6.647 5.41 12.036 12.085 12.036Z"
      />
    </svg>
  );
};

export default Duolingo;
